let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("LNQyj")).then(() => parcelRequire('04bqT'));